import PlanSummary from '../components/PlanSummary'
import { connect } from 'react-redux';
import { planSent, savePlan } from '../actions/plan.js';

const mapStateToProps = (state, ownProps) => {
    return {
    }
};
const mapDispatchToProps = (dispatch, ownProps) => ({
    sendPlan: () => {
        dispatch(planSent());
        ownProps.nextPage();
    }
});



const PlanSummaryPageContainer = connect(
    mapStateToProps, 
    mapDispatchToProps
)(PlanSummary);

export default PlanSummaryPageContainer;
